<template>
  <div>
    <div class="slide_top_bg" v-show="isShow" @click="closeSheet"></div>
    <transition name="van-slide-down">
        <div class="slide_top_wrap" v-show="isShow">
          <slot name="content"></slot>
        </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      isShow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {

      }
    },
    methods: {
      closeSheet() {
        this.$emit('update:isShow', false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .slide_top_bg {
    position:fixed;
    top:60px;
    left:0;
    right:0;
    bottom:0;
    background:rgba(0,0,0,0.7);
    z-index:1;
  }
  .slide_top_wrap {
    background:#fff;
    padding:15px;
    position:fixed;
    top:60px;
    left:0;
    right:0;
    bottom:0;
    z-index:2;
    /*max-height:calc(100vh - 60px);*/
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
